export const ReleaseStatusMenus ={
    outgoing: [
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-pdf",
            emit: "kooi:offer:menu:openpdf",
            key: "openpdf",
            text: 'labels.order.download_pdf',
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "release_v1") != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-times",
            emit: "kooi:offer:menu:reject",
            key: "reject",
            text: "labels.order.reject"
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-check-double",
            emit: "kooi:offer:menu:pod",
            key: "pod",
            text: "labels.release.menus.pod",
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "release_v1") != undefined) }
        },
        {
            key: "sendNow",
            text: "labels.kooi.mails.send_now"
        },
        {
            disabled: false,
            loading: false,
            key: "abort",
            text: "labels.kooi.mails.abort",
            icon: "fas fa-plane-slash",
            emit: "kooi:mails:menu:abort",

        },
    ],
    pod: [
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-pdf",
            emit: "kooi:offer:menu:openpdf",
            key: "openpdf",
            text: 'labels.order.download_pdf',
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "release_v1") != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-times",
            emit: "kooi:offer:menu:reject",
            key: "reject",
            text: "labels.order.reject"
        },

    ],
    rejected: [
        {
            disabled: false,
            loading: false,
            icon: "fas fa-handshake-slash",
            emit: "kooi:menu:status:open",
            key: "open",
            text: "labels.release.menus.set_open"
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-pdf",
            emit: "kooi:offer:menu:openpdf",
            key: "openpdf",
            text: 'labels.order.download_pdf',
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "release_v1") != undefined) }
        },
    ],
    open: [
        {
            disabled: false,
            loading: false,
            icon: "fas fa-clipboard-check",
            emit: "kooi:offer:menu:pdf_validation",
            key: "validatepdf",
            text: "labels.pdf.validation.pdf_validation",
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-pdf",
            emit: "kooi:offer:menu:openpdf",
            key: "openpdf",
            text: 'labels.order.download_pdf',
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "release_v1") != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-paper-plane",
            emit: "kooi:offer:menu:send_email",
            key: "sendmail",
            text: "Send via E-Mail",
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "release_v1") != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-times",
            emit: "kooi:offer:menu:reject",
            key: "reject",
            text: "labels.order.reject"
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-check-double",
            emit: "kooi:offer:menu:pod",
            key: "pod",
            text: "labels.release.menus.pod",
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "release_v1") != undefined) }
        },
    ],
    sent: [
        { key: "view", text: "Show Release" },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-check-double",
            emit: "kooi:offer:menu:pod",
            key: "pod",
            text: "labels.release.menus.pod",
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "release_v1") != undefined) }
        }
    ]
};
